import { ref, onMounted } from 'vue'
import { get } from '../../foundation/js/api.js'

export default {
    name: 'StreamDonationQrCode',
    props: {
        fundraisingId: {
            type: String,
            default: ''
        },
        variation: {
            type: String,
            default: 'dark'
        },
        border: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const qrImgUrlBase = ref('')

        onMounted(async () => {
            if (!props.fundraisingId) return
            const url = `${document.location.origin}/da/api/personalFundraising/${props.fundraisingId}`
            const result = await get(url)
            if (result?.details?.livestreamQrCode) {
                qrImgUrlBase.value = result.details.livestreamQrCode
            }
        })

        return { qrImgUrlBase }
    }
}
